import cn from 'classnames';
import { useRouter } from '@framework/router';
import { Link } from '@framework/router/Next/Link';
import Flex from '@creditflowresearch/uilib/Flex';
import Badge from '@/creditflowresearch/ui/common/components/atoms/Badge';
import { getMarketColor } from '@/creditflowresearch/ui/common/utils/markets/marketStyleHelpers';
import { IUrlObject, closePanelOnNavigate } from '@creditflowresearch/uilib/PanelControl';

import styles from './linkPanelButton.module.scss';

export interface ILinkPanelButton {
  label: React.ReactNode,
  abbreviation: string,
  link?: string | IUrlObject,
  isActive?: boolean,
}

const LinkPanelButton = ({
  label,
  isActive,
  link = '',
  abbreviation,
}: ILinkPanelButton) => {
  const { asPath } = useRouter();
  const activeLink = isActive ?? asPath.includes(typeof link === 'string' ? link : link?.pathname);

  return (
    <Link
      to={ link }
      dataTest={ `panelButton-${ abbreviation }` }
      onClick={ closePanelOnNavigate }
      aria-current={ activeLink ? 'page' : undefined }
    >
      <Flex
        align="center"
        justify="space-between"
        gap={ { sm: 0, md: 10, xl: 10 } }
        wrap="nowrap"
        className={ styles.panelButtonContainer }
      >
        <Flex align="center" gap={ 10 } wrap="nowrap" className={ styles.buttonGroupContainer }>
          <Badge color={ getMarketColor(abbreviation) } isActive={ activeLink } text={ abbreviation } />
          <Flex
            align="center"
            justify="space-between"
            className={ cn(styles.panelLink, { [styles.isActive]: activeLink }) }
          >
            { label }
          </Flex>
        </Flex>
      </Flex>
    </Link>
  );
};

export default LinkPanelButton;
